<!-- 定制订单管理 -->
<style scoped>
.width150 {
  width: 150px;
}
.red {
  color: red;
}
</style>
<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <!-- 搜索条件 -->
      <a-form-model
        size="small"
        layout="inline"
        :model="ajaxparams"
        @keyup.native.enter="search()"
      >
        <a-form-model-item label="业务员">
          <a-input
            placeholder="请输入业务员名称"
            v-model="ajaxparams['salesman_no']"
          />
        </a-form-model-item>
        <a-form-model-item label="订单号">
          <a-input
            placeholder="请输入订单号"
            v-model="ajaxparams['1_order_sn_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="用户昵称">
          <a-input
            placeholder="请输入用户昵称"
            v-model="ajaxparams['2_name_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="用户手机号">
          <a-input
            placeholder="请输入用户手机号"
            v-model="ajaxparams['2_mobile_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="订单状态" prop="order_status">
          <a-select
            allowClear
            class="width150"
            v-model="ajaxparams['1_order_status']"
            placeholder="请选择订单状态"
          >
            <a-select-option :value="0">关闭</a-select-option>
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">完成</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="支付状态" prop="pay_status">
          <a-select
            allowClear
            class="width150"
            v-model="ajaxparams['1_pay_status']"
            placeholder="请选择支付状态"
          >
            <a-select-option :value="0">未支付</a-select-option>
            <a-select-option :value="1">已支付</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="支付方式" prop="pay_method">
          <a-select
            allowClear
            class="width150"
            v-model="ajaxparams['1_pay_method']"
            placeholder="请选择支付方式"
          >
            <a-select-option value="aliPay">支付宝</a-select-option>
            <a-select-option value="balance">余额/共富币</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否预售" prop="is_presale">
          <a-select
            allowClear
            class="width150"
            v-model="ajaxparams['is_presale']"
            placeholder="请选择"
          >
            <a-select-option :value="1">是</a-select-option>
            <a-select-option :value="0">否</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="发货状态" prop="delivery_status">
          <a-select
            allowClear
            class="width150"
            v-model="ajaxparams['1_delivery_status']"
            placeholder="请选择发货状态"
          >
            <a-select-option :value="0">未发货</a-select-option>
            <a-select-option :value="1">部分发货</a-select-option>
            <a-select-option :value="2">已发货</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="收货人">
          <a-input
            placeholder="请输入收货人"
            v-model="ajaxparams['1_consignee_name_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="收货人联系方式">
          <a-input
            placeholder="请输入收货人联系方式"
            v-model="ajaxparams['1_consignee_mobile_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="商品名称">
          <a-input
            placeholder="请输入商品名称"
            v-model="ajaxparams['3_goods_name_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="结算日期">
          <a-date-picker
            v-model="ajaxparams['1_settle_date']"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            value="null"
          />
        </a-form-model-item>
        <a-form-model-item label="省份">
          <a-select
            style="width: 200px"
            allowClear
            v-model="ajaxparams['1_province_code']"
            placeholder="请选择省份"
            :showSearch="true"
            optionFilterProp="label"
          >
            <a-select-option
              :label="item.name"
              :value="item.code"
              v-for="(item, index) in provinceData"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="日期">
          <a-range-picker
            v-model="ajaxparams['1_ctime_between']"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            value="null"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button icon="search" @click="search()" type="primary">
            搜索</a-button
          >
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="doExport" type="primary"> 导出 </a-button>
        </a-form-model-item>
        <a-form-model-item label="支付金额" v-if="extraData"
          >¥{{ extraData }}</a-form-model-item
        >
      </a-form-model>
      <MyTable
        class="mt10"
        :apiUrl="orders_index"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
      >
        <a-space slot="order_sn" slot-scope="item, row">
          <router-link
            target="_blank"
            :to="{
              path: '/orders/detail',
              query: { id: row.order_sn, customized: 'customized' },
            }"
            :class="{ red: row.consignee_address_confirm == 0 }"
          >
            <span>{{ row.order_sn }}</span>
          </router-link>
        </a-space>

        <a-space slot="order_status_gather" slot-scope="item, row">
          <span>{{ orderStatusName[row.order_status_gather] }}</span>
        </a-space>
        <a-space slot="order_type" slot-scope="item, row">
          <span>{{
            row.order_type == 0 ? "关闭" : row.order_type == 1 ? "正常" : "完成"
          }}</span>
        </a-space>
        <a-space slot="pay_status" slot-scope="item, row">
          <span>{{ row.pay_status == 0 ? "未支付" : "已支付" }}</span>
        </a-space>
        <a-space slot="pay_method" slot-scope="item, row">
          <span>{{
            row.pay_method == "aliPay" ? "支付宝" : "余额/共富币"
          }}</span>
        </a-space>
        <a-space slot="is_presale" slot-scope="item, row">
          <span>{{ row.is_presale == 0 ? "否" : "是" }}</span>
        </a-space>
        <a-space slot="manage_id" slot-scope="item">
          <span>{{ salesmen[item] ? salesmen[item]["name"] : "-" }}</span>
        </a-space>

        <a-space slot="delivery_status" slot-scope="item, row">
          <span>{{
            row.delivery_status == 0
              ? "未发货"
              : row.delivery_status == 1
              ? "部分发货"
              : "已发货"
          }}</span>
        </a-space>
        <a-space slot="goods_amount" slot-scope="item, row">
          <span>{{
            $common.countFloat(
              (row.goods_amount ? row.goods_amount : 0) / 100,
              2
            )
          }}</span>
        </a-space>
        <a-space slot="payed_amount" slot-scope="item, row">
          <span>{{
            $common.countFloat(
              (row.payed_amount ? row.payed_amount : 0) / 100,
              2
            )
          }}</span>
        </a-space>
        <a-space slot="source_path" slot-scope="item, row">
          <span>{{
            source_paths[row.source_path] ? source_paths[row.source_path] : "-"
          }}</span>
        </a-space>
        <a-space slot="order_amount" slot-scope="item, row">
          <span>{{
            $common.countFloat(
              (row.order_amount ? row.order_amount : 0) / 100,
              2
            )
          }}</span>
        </a-space>
        <a-space slot="coupon_discount_amount" slot-scope="item, row">
          <span>{{
            $common.countFloat(
              (row.coupon_discount_amount ? row.coupon_discount_amount : 0) /
                100,
              2
            )
          }}</span>
        </a-space>
        <a-space slot="address" slot-scope="item, row">
          <span>{{ row.consignee_area + " " + row.consignee_address }}</span>
        </a-space>
      </MyTable>
    </div>
  </div>
</template>
<script>
import MyTable from "@/components/myTable.vue";
import { orders_index } from "@/api/orders";
import { users_salesman } from "@/api/users";
import { order_index } from "@/api/export";
import moment from "moment";

export default {
  components: { MyTable },
  data() {
    return {
      orders_index: orders_index,
      IMGHOST: window.IMGHOST,

      ajaxparams: {
        "1_is_customized": 1, // 固定为1，表示定制订单
      }, //请求参数
      /*
			列表header
		*/
      columns: [
        {
          title: "订单号",
          ellipsis: true,
          width: 220,
          dataIndex: "order_sn",
          key: "order_sn",
          scopedSlots: { customRender: "order_sn" },
        },
        {
          title: "用户名称",
          ellipsis: true,
          dataIndex: "name",
          key: "name",
          width: 100,
        },
        {
          title: "业务员",
          dataIndex: "manage_id",
          key: "manage_id",
          width: 100,
          scopedSlots: { customRender: "manage_id" },
        },
        {
          title: "是否预售",
          ellipsis: true,
          dataIndex: "is_presale",
          key: "is_presale",
          width: 100,
          scopedSlots: { customRender: "is_presale" },
        },
        {
          title: "订单状态",
          ellipsis: true,
          dataIndex: "order_status_gather",
          key: "order_status_gather",
          width: 100,
          scopedSlots: { customRender: "order_status_gather" },
        },
        {
          title: "支付状态",
          ellipsis: true,
          dataIndex: "pay_status",
          key: "pay_status",
          width: 100,
          scopedSlots: { customRender: "pay_status" },
        },
        {
          title: "发货状态",
          ellipsis: true,
          dataIndex: "delivery_status",
          key: "delivery_status",
          width: 100,
          scopedSlots: { customRender: "delivery_status" },
        },
        {
          title: "加购礼品",
          ellipsis: true,
          dataIndex: "additional_goods_info",
          key: "additional_goods_info",
          width: 120,
        },
        {
          title: "支付方式",
          ellipsis: true,
          dataIndex: "pay_method",
          key: "pay_method",
          width: 120,
          scopedSlots: { customRender: "pay_method" },
        },
        {
          title: "结算日期",
          ellipsis: true,
          dataIndex: "settle_date",
          key: "settle_date",
          width: 120,
          scopedSlots: { customRender: "settle_date" },
        },
        {
          title: "订单商品金额",
          ellipsis: true,
          dataIndex: "goods_amount",
          key: "goods_amount",
          width: 120,
          scopedSlots: { customRender: "goods_amount" },
        },
        {
          title: "订单金额",
          ellipsis: true,
          dataIndex: "order_amount",
          key: "order_amount",
          width: 120,
          scopedSlots: { customRender: "order_amount" },
        },
        {
          title: "订单支付金额",
          ellipsis: true,
          dataIndex: "payed_amount",
          key: "payed_amount",
          width: 120,
          scopedSlots: { customRender: "payed_amount" },
        },
        {
          title: "订单备注",
          ellipsis: true,
          dataIndex: "user_remark",
          key: "user_remark",
          width: 200,
        },
        {
          title: "商家备注",
          ellipsis: true,
          dataIndex: "merchant_remark",
          key: "merchant_remark",
          width: 200,
          scopedSlots: { customRender: "merchant_remark" },
        },
        {
          title: "收货人姓名",
          ellipsis: true,
          dataIndex: "consignee_name",
          key: "consignee_name",
          width: 150,
          scopedSlots: { customRender: "consignee_name" },
        },
        {
          title: "收货人联系方式",
          ellipsis: true,
          dataIndex: "consignee_mobile",
          key: "consignee_mobile",
          width: 150,
          scopedSlots: { customRender: "consignee_mobile" },
        },
        {
          title: "收货人地址",
          ellipsis: true,
          dataIndex: "address",
          key: "address",
          width: 250,
          scopedSlots: { customRender: "address" },
        },
        {
          title: "下单ip",
          ellipsis: true,
          dataIndex: "order_ip",
          key: "order_ip",
          width: 150,
          scopedSlots: { customRender: "order_ip" },
        },
        {
          title: "下单地域",
          dataIndex: "order_area",
          key: "order_area",
          width: 150,
          scopedSlots: { customRender: "order_area" },
        },
        {
          title: "来源页面",
          ellipsis: true,
          dataIndex: "source_path",
          key: "source_path",
          width: 200,
          scopedSlots: { customRender: "source_path" },
        },
        {
          title: "取消备注",
          ellipsis: true,
          dataIndex: "cancel_remark",
          key: "cancel_remark",
          width: 200,
          scopedSlots: { customRender: "cancel_remark" },
        },
        {
          title: "创建时间",
          ellipsis: true,
          dataIndex: "ctime",
          key: "ctime",
          width: 220,
        },
        {
          title: "更新时间",
          ellipsis: true,
          dataIndex: "utime",
          key: "utime",
          width: 220,
        },
      ],
      orderStatusName: {
        "-1": "关闭",
        1: "待付款",
        2: "待发货",
        3: "部分发货",
        4: "已发货",
        5: "待评价",
        6: "售后中",
        7: "交易成功",
      },
      source_paths: {
        "pages/tab/home": "首页",
        "pages/tab/cart": "购物车",
        "pages/tab/msg": "消息",
        "views/goods/goods": "商品详情",
        "views/goods/classIfyGoods": "分类商品",
        "views/goods/recommend": "推荐商品",
        "views/goods/search": "搜索",
        "views/order/detail": "订单详情",
      },
      provinceData: [],
      extraData: 0,
      timer: null,
      salesmen: {},
    };
  },
  mounted() {
    this.regionData = this.$db.get("regionList").data;
    this.provinceData = this.regionData.filter((item) => {
      return item.depth == 1;
    });

    this.salesmen = this.$db.get("salesmen");
    if (!this.salesmen) {
      users_salesman().then((res) => {
        this.salesmen = res;
      });
    }
  },
  methods: {
    doExport() {
      //导出
      if (
        !this.ajaxparams["1_ctime_between"] &&
        !this.ajaxparams["1_settle_date"]
      ) {
        this.$message.warning("请选择导出日期");
        return;
      }
      order_index(this.ajaxparams).then(
        (res) => {
          this.$message.success("添加导出队列成功");
          this.$db.set("is_export", 1);
        },
        (err) => {
          this.$message.warning("导出失败");
        }
      );
    },
    search() {
      let _this = this;
      this.$refs.myTable.search();

      clearInterval(this.timer);
      this.timer = setInterval(() => {
        _this.extraData = _this.$refs.myTable.extraData / 100;
        if (_this.extraData) clearInterval(_this.timer);
      }, 800);
    },
  },
};
</script>
